import _property from 'lodash/property';

var createdTime = _property('createdTime');

var dealerId = _property('dealerId');

var doorAmount = _property('doorAmount');

var glAccount = _property('glAccount');

var id = _property('id');

var key = _property('key');

var lastModifiedBy = _property('lastModifiedBy');

var modifiedTime = _property('modifiedTime');

var name = _property('name');

var status = _property('status');

var userId = _property('userId');

var READER = {
  createdTime: createdTime,
  dealerId: dealerId,
  doorAmount: doorAmount,
  glAccount: glAccount,
  id: id,
  key: key,
  lastModifiedBy: lastModifiedBy,
  modifiedTime: modifiedTime,
  name: name,
  status: status,
  userId: userId
};
export default READER;